import React from "react";

const FooterAccessibilityButton = () => {
	return (
		<a href="https://www.essentialaccessibility.com:443/msd">
			<img src="https://assets.msd-animal-health.com:443/brands/accessibility/img/accessibility.png" alt="Botão de Acessibilidade" />
		</a>
	);
};

export default FooterAccessibilityButton;
